<template lang="pug">
    section.abonement
        el-row.no-margin(:gutter="20")
            el-col(:sm="12")
                .api-keys(v-if="needsMapBox || needsGoogleRecaptcha || needsSmtpCredentials")
                    MapBoxKey(v-if="needsMapBox" :cms="form")
                    GoogleRecaptchaKeys(v-if="needsGoogleRecaptcha" :cms="form")
                    SmtpCredentials(v-if="needsSmtpCredentials" :cms="form")
                    StripeKeys(v-if="needsStripe" :cms="form")
                    .paypal-api-keys(v-if="needsPayPal || needsUps")
                        h4 {{ $t('PayPal Checkout') }}
                            p
                                small {{ $t('Production') }}
                        PayPalKeys(:cms="form")
                        h4
                            p
                                small {{ $t('Sandbox') }}
                        PayPalKeys(:cms="form" env="sandbox")
                    UpsKeys(v-if="needsUps" :cms="form")
            el-col(:sm="12")
                .groups
                    transition-group(name="slide-decent-vertical")
                        .row(
                            v-for="(group, i) in groups" :key="i"
                            v-if="checkConditions(group)"
                        )
                            transition-group.flex(name="slide-decent-vertical")
                                SettingField.setting-field(
                                    v-for="field in group.fields"
                                    v-if="checkConditions(field)"
                                    :key="field.key"
                                    :field="field"
                                    :setting-values="settingValues"
                                )
                el-collapse(accordion v-if="blocks && blocks.length")
                    transition-group(name="slide-decent-vertical")
                        el-collapse-item(
                            v-for="block in blocks" :key="block.key"
                            v-if="checkConditions(block)"
                            :title="block.name"
                            :name="block.key"
                        )
                            transition-group(name="slide-decent-vertical")
                                .row(
                                    v-for="(group, i) in block.groups" :key="block.key+i"
                                    v-if="checkConditions(group)"
                                )
                                    transition-group.flex(name="slide-decent-vertical")
                                        SettingField.setting-field.no-margin(
                                            v-for="field in group.fields"
                                            v-if="checkConditions(field)"
                                            :key="field.key"
                                            :field="field"
                                            :setting-values="settingValues"
                                        )
</template>

<script>

import _ from 'lodash'
import { mapGetters } from 'vuex'

import store from '@/store'
import AuthApi from '@/store/api/system/auth';

import MapBoxKey from './Partials/MapBoxKey'
import GoogleRecaptchaKeys from './Partials/GoogleRecaptchaKeys'
import SmtpCredentials from './Partials/SmtpCredentials'
import PayPalKeys from './Partials/PayPalKeys'
import StripeKeys from './Partials/StripeKeys'
import Domain from './Partials/Domain'

import SettingField from './Partials/SettingField'
import UpsKeys from './Partials/UpsKeys'

export default {
    name: 'AbonementAPI',
    data() {
        const token = AuthApi.getToken('mimic') || AuthApi.getToken()
        return {
            uploadHeaders: {
                authorization: `Bearer ${token}`
            },
        }
    },
    components: {
        Domain,
        MapBoxKey,
        GoogleRecaptchaKeys,
        SmtpCredentials,
        StripeKeys,
        PayPalKeys,
        // JsSnippets,
        // CssSnippets,
        SettingField,
        UpsKeys
    },
    computed: {
        settings() {
            const settings = _.get(this.form, 'config.template.settings') || []
            return settings.find(el => el.key === 'api')
        },
        blocks() {
            return _.get(this.settings, 'blocks') || []
        },
        groups() {
            return _.get(this.settings, 'groups') || []
        },
        template: {
            get() {
                return _.get(this.form, 'config.template')
            },
            set(value) {
                store.commit(`settings/form/template`, value)
            }
        },
        requirements() {
            return _.get(this.template, 'requirements') || []
        },
        needsMapBox() {
            return !!this.requirements.find(requirement => {
                return requirement.key === 'mapbox' && requirement.context === 'cms'
            })
        },
        needsGoogleRecaptcha() {
            return !!this.requirements.find(requirement => {
                return requirement.key === 'google-recaptcha-v3' && requirement.context === 'cms'
            })
        },
        needsSmtpCredentials() {
            return !!this.requirements.find(requirement => {
                return requirement.key === 'smtp-credentials' && requirement.context === 'cms'
            })
        },
        needsPayPal() {
            return this.shop && this.requirements.find(requirement => {
                return requirement.key === 'paypal-checkout' && requirement.context === 'shop'
            })
        },
        needsStripe() {
            return this.shop && this.requirements.find(requirement => {
                return requirement.key === 'stripe' && requirement.context === 'shop'
            })
        },
        needsUps() {
            return !!this.requirements.find(requirement => {
                return requirement.key === 'ups-account-nr' && requirement.context === 'shop'
            })
        },
        hasDesignSettings() {
            const settings = _.get(this.form, 'config.template.settings') || []
            if (settings.find(el => el.key === 'design')) return true
            else return false;
        },
        shop: {
            get() {
                const extensions = this.form.extensions || []
                return !!extensions.find(extension => extension.key === 'shop')
            },
            set(value) {
                if (value === true) {
                    store.commit(`settings/form/createShop`)
                    store.commit(`settings/form/addExtension`, { key: 'shop' })
                } else {
                    // store.commit(`account/form/administrator/deleteShop`, this.index)
                    store.commit(`settings/form/removeExtension`, { key: 'shop' })
                }
            }
        },
        ...mapGetters({
            form: 'settings/form',
            options: 'settings/options',
            settingValues: 'settings/values',
        })
    },
    methods: {
        checkConditions(setting) {
            let valid = true

            // eslint-disable-next-line no-unused-vars
            const settings = this.settingValues;
            try {
                const conditions = setting.conditions
                if (conditions && conditions.length) {
                    conditions.forEach(o => {
                        if (valid === false) return

                        const { type, condition } = o
                        switch (type) {
                            case 'eval':
                                valid = eval(condition)
                                break;

                            default:
                                valid = false
                        }
                    })
                }
            } catch (error) {
                // eslint-disable-next-line
                console.error(error);
                valid = false
            }

            return valid
        },
    }
}
</script>

<style lang="sass" scoped>
.api-keys
    > div
        &:hover:before
            background: lighten($--color-primary, 20%)
        &:focus-within:before
            background: $--color-primary

    .paypal-api-keys
        padding-left: 12px
        position: relative
        &:before
            content: ''
            position: absolute
            left: 0
            top: 0
            bottom: 0
            width: 4px
            background: rgba($color-grey-text, .2)
            border-radius: 6px
        h4
            color: $color-grey-text
</style>
